import { ICategoryForm, IAssetSearchForm } from '@/types/asset.d';
import fetch from './index';

// 获取素材分类
const getCategoryList = () => fetch.axios_admin.get('/scratch/material/category');

// 创建素材分类
const createCategory = (data: ICategoryForm) => {
  const datas: URLSearchParams = new URLSearchParams();
  datas.append('label', data.label);
  return fetch.axios_admin.post('/scratch/material/category', datas, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
};

// 上传sb3资源文件素材
const uploadSb3Asset = (file: File): Promise<any> => {
  const data: FormData = new FormData();
  data.append('file', file);
  // 不需要使用注入器 Promise.all 执行时才可调用此方法
  /* eslint-disable quote-props */
  return fetch.axios_admin.post('/scratch/materialFile',
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Reply': true,
      },
    });
};

// 上传素材资源json
const uploadAssetJson = (data: any) => fetch.axios_admin.post('/scratch/materials', data);

// 获取资源Json
const getAssetJson = (params: IAssetSearchForm) => fetch.axios_admin.get('/scratch/material', { params });

// 创建资源和章节的关系
const createChapterAsset = (data: { cid: string, mids: string }) => {
  const params: URLSearchParams = new URLSearchParams();
  params.append('cid', data.cid);
  params.append('mids', data.mids);
  return fetch.axios_admin.post('/course/chapter/scratch/material', {}, {
    params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

// 将素材分配给公共素材
const allotPulicAsset = (ids: string) => fetch.axios_admin.post('/scratch/commons/materials', ids);

// 移除素材
const deleteAsset = (ids: string) => fetch.axios_admin.remove(`/scratch/material?ids=${ids}`);

// 获取公共素材
const getPublicAsset = (params: IAssetSearchForm) => fetch.axios_admin.get('/scratch/commons/material', { params });

// 删除公共素材
const deletePublicAsset = (ids: string) => fetch.axios_admin.remove(`/scratch/commons/material?ids=${ids}`);

// 修改素材名字
const editAssetName = (data: any) => fetch.axios_admin.post('/scratch/material/name', data);

const editPublicAssetSort = (data: any) => {
  const params: URLSearchParams = new URLSearchParams();
  params.append('id', data.id);
  params.append('sequence', data.sequence);
  return fetch.axios_admin.put('/scratch/commons/material/sequence', {}, {
    params,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

export default {
  getCategoryList,
  createCategory,
  uploadSb3Asset,
  uploadAssetJson,
  getAssetJson,
  createChapterAsset,
  deleteAsset,
  allotPulicAsset,
  getPublicAsset,
  deletePublicAsset,
  editAssetName,
  editPublicAssetSort,
};
